import {createAsyncThunk} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import instance from '@/config/axios'

export const getRefunds = createAsyncThunk('refund/getCalendar',
  async (params: any) => {
 		const paramText = new URLSearchParams(params)
    const url = `v1/refunds?${paramText}`
    const response: AxiosResponse<GeneralArrayResponse<Refund>> = await instance.get(url)
    return response.data
  })
